var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "more_options_button",
    "data-name": "more options button",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18218",
    "data-name": "Rectangle 18218",
    width: 20,
    height: 20,
    rx: 2,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12595",
    "data-name": "Group 12595",
    transform: "translate(-3822 -2776)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_245",
    "data-name": "Ellipse 245",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(3830 2790)",
    fill: "#455079"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_244",
    "data-name": "Ellipse 244",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(3830 2784)",
    fill: "#455079"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_243",
    "data-name": "Ellipse 243",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(3830 2778)",
    fill: "#455079"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.40d8b1c70f086ad256eed85e2f35ce6d.svg";
export { ForwardRef as ReactComponent };